import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/template-uri')({
  component: TemplateUriLayout,
});

/**
 * Cadrul zonei de template-uri: lista și editorul.
 *
 * `Header` și `Main` stau în layout, ca la `/clienti` — două ecrane cu același antet,
 * scris o dată.
 *
 * **Editorul cere `Main fixed`, lista nu.** `fixed` dă înălțimea ecranului și oprește
 * scroll-ul paginii (`has-data-[layout=fixed]:h-svh` din shell), ca să scrolleze doar
 * coala, cu bara de formatare și structura pe loc. Pe listă ar fi tăiat rândurile de jos.
 */
function TemplateUriLayout() {
  const inEditor = useRouterState({
    select: (state) => state.location.pathname.replace(/\/$/, '') !== '/template-uri',
  });

  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Template-uri</h1>
      </Header>

      <Main fixed={inEditor} className="flex flex-1 flex-col gap-4 sm:gap-6">
        <Outlet />
      </Main>
    </>
  );
}
